import React from 'react';
import MapPinIcon from './MapPinIcon';

// BookmarksScrubber — replaces the static "Bookmarks" list from the Figma with
// a horizontal progress bar that tracks the user's reading progress through the PDF.
//
// Props:
//   currentPage       — 1-indexed current page (from PdfViewer).
//   numPages          — total PDF pages. Falsy during load.
const BookmarksScrubber = ({ currentPage = 1, numPages = 0 }) => {
  // Convert page number (1..numPages) to a %
  const pagePct = (page) => {
    if (!numPages || numPages <= 1) return 0;
    return ((page - 1) / (numPages - 1)) * 100;
  };

  const currentPct = pagePct(currentPage);

  return (
    <div className="relative mt-2 mb-4 w-full pt-6">
      <div
        className="relative h-2 w-full rounded-full bg-v5-neutral-200"
        role="progressbar"
        aria-label="Brochure reading progress"
        aria-valuemin={1}
        aria-valuemax={numPages || 1}
        aria-valuenow={currentPage}
      >
        {/* Map-like floating pin */}
        <div
          className="absolute z-10 -translate-x-1/2 text-v5-green-600 drop-shadow-md transition-all duration-300 ease-out"
          style={{
            left: `${currentPct}%`,
            bottom: '100%',
            marginBottom: '-6px',
          }}
        >
          <MapPinIcon className="h-6 w-6" />
        </div>

        {/* Filled progress track */}
        <div
          className="h-full rounded-full bg-v5-green-600 opacity-90 transition-all duration-300 ease-out"
          style={{ width: `${currentPct}%` }}
        />
      </div>
    </div>
  );
};

export default BookmarksScrubber;
